// Legal document versions per the compliance implementation spec.
// A single source of truth for versions/effective dates shown on pages and
// recorded in the append-only consent_records collection.
//
// When a document is materially updated, add a NEW entry here (do NOT overwrite
// the old one) and update the page to render the new version. Historical
// consent records must continue to reference the version they accepted.

export const LEGAL_DOCUMENTS = {
  terms: {
    id: "terms",
    version: "terms-v2.0-2026-07",
    label: "Terms of Use",
    path: "/terms",
    effectiveDate: "July 2026",
  },
  privacy: {
    id: "privacy",
    version: "privacy-v2.0-2026-07",
    label: "Privacy Policy",
    path: "/privacy",
    effectiveDate: "July 2026",
  },
  cookies: {
    id: "cookies",
    version: "cookies-v2.0-2026-07",
    label: "Cookie Policy",
    path: "/cookies",
    effectiveDate: "July 2026",
  },
  tcpa: {
    id: "tcpa",
    version: "tcpa-v2.0-2026-07",
    label: "TCPA & Electronic Communications Consent",
    path: "/communications-consent",
    effectiveDate: "July 2026",
  },
  esign: {
    id: "esign",
    version: "esign-v2.0-2026-07",
    label: "Electronic Signature & Electronic Records Consent",
    path: "/esign-consent",
    effectiveDate: "July 2026",
  },
  authorization: {
    id: "authorization",
    version: "authorization-v2.0-2026-07",
    label: "Funding Application Authorization and Verification Consent",
    path: "/application-authorization",
    effectiveDate: "July 2026",
  },
  disclaimer: {
    id: "disclaimer",
    version: "disclaimer-v2.0-2026-07",
    label: "Website Disclaimer",
    path: "/disclaimer",
    effectiveDate: "July 2026",
  },
};

export const CONSENT_UI_VERSION = "consent-ui-v2.0-2026-07";
export const APPLICATION_FORM_VERSION = "app-form-v2.0-2026-07";

// Whether to display the optional marketing communications checkbox on the
// application form. Kept as a compile-time flag: only set to true once
// Hannah Howard Funding intends to send promotional messages AND a Twilio
// 10DLC marketing campaign has been registered.
export const MARKETING_CONSENT_ENABLED = false;
